import {register} from 'swiper/element/bundle';
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import style from "./style.module.css";
import { intervalToDuration, formatDuration } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import patinhas1 from '../../../images/patinhas1.svg';
import patinhas2 from '../../../images/patinhas2.svg';
import setaesquerda from '../../../images/setaesquerda.svg';
import setadireita from '../../../images/setadireita.svg';
import { useRef } from 'react';
import { useCallback } from 'react';
import {Spinner} from "react-bootstrap";
import ModalAnimal from "../../Modals/ModalInfoAnimal";


import React from "react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import BaseApi from '../../../services/Api';


import { toast } from "react-toastify";

const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
  };


export default function SlideBestFriend(props){

    const [cards, setCards] = React.useState(3);
    const[images, setImages] = useState(true);

    window.addEventListener("resize", function(){
        if(this.window.innerWidth <= 1100){
            setCards(1);
        }
        else{
            setCards(3);
        }
        if(this.window.innerWidth > 1100){
            setImages(true)
        }
        else{
            setImages(false)
        }
    });


    const visible = (()=>{
        if(window.innerWidth <= 1100){
            setCards(1);
        }
        else{
            setCards(3);
        }
        if(window.innerWidth > 1100){
            setImages(true)
        }
        else{
            setImages(false)
        }
    })



    useEffect(() => {
        visible();
    }, []);

    const handleDate = (birthday) => {
        const todayDate = new Date();
        const birthdayDate = new Date(birthday);
    
        let duration = intervalToDuration({
          start: birthdayDate, 
          end: todayDate,
        });
        if (duration.years === 0 && duration.months > 0) {
          if(duration.months == 1){
              return `${duration.months} mes`;

          }else{
              return `${duration.months} meses`;

          }
          } else

          {
            if(duration.years==0 && duration.months == 0){
              if(duration.days == 1){
                  return `${duration.days} dia`;
              }else{
                  return `${duration.days} dias`;
              }
            }else{
                return formatDuration(duration, {
                    format: ['years'],
                    delimiter: ' e ',
                    locale: ptBR
                });
            }

          }
    }

return(
    <div className={style.all}>
    <div className={style.container}>
        <img src={patinhas1} className={style.patinhas1}/>
        {images && (
            <img src={patinhas2} className={style.patinhas2}/>
        )}

            <h1 className={style.title}>CONHEÇA SEU NOVO MELHOR AMIGO!</h1>


        <div className={style.cardContainer}>

            <Swiper className={style.swiperedit}
                    slidesPerView={cards>props.animalsData.length ? props.animalsData.length : cards}
                    loop={true}
                    observeParents={true}
                    observer={true}
                    navigation
            >
                {props.animalsData.map((item)=>
                    (


                        <SwiperSlide key={item.id}>

                            <div className={style.card_list}>
                                <ModalAnimal
                                    idAnimal={item.id}>
                                <div className={style.card}>
                                    <h2 className={style.BestFriendName}> {item.name}</h2>
                                    <img src={item.animal_img} alt="" className={style.bestFriendImg}/>
                                    <div className = {style.know}> <p>Conheça {item.sex == "female" ? "a" : "o"} {item.name}</p> </div>
                                    <div className={style.BestFriendInformations}>
                                        <div className={style.description}>
                                            <p className={style.particulars}> {handleDate(item.birthday)} / {item.is_castrated == 1 ? (item.sex=="female" ? "Castrada" : "Castrado"): (item.sex=="female" ? "Não Castrada" : "Não Castrado")} / {item.species == "dog" ? "Cachorro": "Gato"} / {item.sex == "female" ? "Fêmea": "Macho"} / Porte {item.size == "small" ? "pequeno": item.size == "medium" ? "médio": "grande"}</p>
                                            <p className={style.bestFriendDescription}> {item.description}</p>
                                        </div>
                                    </div>
                                </div>
                                </ModalAnimal>
                            </div>

                        </SwiperSlide>

                    )
                )}
            </Swiper>


        </div>
    
            <div className={style.buttoncenter}>
                <a href = "/animais">
            <button className={style.buttonMore}>VER MAIS</button>
            </a>
            </div>
            
        </div>
          
        </div>
)
}